import { render, staticRenderFns } from "./ModalCapitalizacion.vue?vue&type=template&id=e5ff3700&scoped=true&"
import script from "./ModalCapitalizacion.vue?vue&type=script&lang=js&"
export * from "./ModalCapitalizacion.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e5ff3700",
  null
  
)

export default component.exports